<template>
  <div class="login">
    <div class="cl-logo">
      <!-- <img src="../../assets/images/cloudlogoimage.png" class="cl-cloudImage"> -->
    </div>
    <div class="cl-suss">
      <div class="login-con">
         <img class="successRegister" src="../../assets/images/successRegister.png" alt="">
         <h1>注册成功</h1>
         <el-button class="cl-button" type="primary" @click="login">登录</el-button>
      </div>
    </div>
<!--    <div class="cl-info">
      <img src="../../assets/images/clmobile.png" class="cl-telImage">
      <div class="cl-text">COPYRIGHT © 2020-2025 版权所有：国际海运网 联系地址：辽宁省大连市中山区人民路50号时代广场B座1601</div>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'index',
  data() {
    return {

    }
  },
  created(){

  },
  mounted() {

  },
   methods: {
     login() {
       this.$router.push({
         name: "login",
         query: {

         }
       })
     }
  },
  components: {

  }
}
</script>

<style lang="scss" scoped>
  .login{
    background-color: rgb(240, 242, 245);
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/cloudplatform.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-attachment: fixed
  }
  .cl-logo{
    padding-top:30px;
    padding-left:30px;
    width: auto;
  }
  .cl-cloudImage{
    width: auto;
    height: 30px;
  }
  .cl-loginlogo{
    text-align: center;
    margin: 0;
    margin-top: 100px;
  }
  .cl-loginlogo img{
    width: auto;
    height: 55px;
  }
  .cl-info{
    position: absolute;
    bottom: 10px;
    margin-left:2%;
    width: 98%;
  }
  .cl-telImage{
    width: auto;
    height: 35px;
  }
  .cl-text{
    float: right;
    margin-top: 20px;
    margin-right: 20px;
    bottom: 0px;
    font-size: 8px;
    font-family:"微软雅黑";
    color: dimgrey;
  }
  .cl-suss{
    position: fixed;
    right: 10%;
    top: 18%;
  }
  .login-con{
    width: 340px;
    padding: 50px 30px 50px 30px;
    background-color: #fff;
  }
  .cl-button{
    width: 100%;
    margin-top: 40px;
  }
  .successRegister{
    display: block;
    width: 90px;
    height: 90px;
    margin: 20px auto;
  }
  .login-con h1{
    margin-top: 30px;
    font-size: 24px;
    text-align: center;
  }
</style>
